'use strict';

var connect = require('../../modules/store/results').connect;
var viewInjectorUtils = require('../../modules/views/view_injector_utils');
var createView = viewInjectorUtils.createView;
var createInjector = viewInjectorUtils.createInjector;
var MainView = require('./view');
var MatchedResultsView = require('../../modules/views/results/matched_results.view');
var TagsView = require('../../modules/views/results/applied_filters_summary.view');
var TagView = require('./tag.view');

var TagsContainer = connect(function(state) {
    return state.get('tags');
})(TagsView);

var MainContainer = connect(function(state) {
    return new Backbone.Model({
        numResults: state.get('numResults'),
    });
})(MainView);

var MatchedResultsContainer = connect(function(state) {
    return state.get('numResults');
})(MatchedResultsView);

var createContainerView = function(viewFactories) {
    var widget = this.widget;
    return createView(viewFactories, MainContainer, {
        el: this.$el[0],
        widgetId: widget.id,
        tagsForFiltersOnTop: widget.options.tagsForFiltersOnTop,
        keys: this.keys,
        templates: this.templates,
    });
};

var createMatchedResultsView = function(viewFactories) {
    return createView(viewFactories, MatchedResultsContainer, {
        numMatchesMessage: this.keys.numMatchesMessage,
        el: '.flights_filters_summary_panel',
    }).render();
};

var createTagsView = function(viewFactories) {
    return createView(viewFactories, TagsContainer, {
        el: '.tag_filter_container',
        summaryLabel: {
            viewClass: TagView,
            className: 'od-tag-filter odf-pills odf-pills-soft-informative odf-pills-noarrow ' +
            'odf-hoverable odf-space-outer-top-xs odf-space-outer-bottom-xs open',
        },
        templates: this.templates,
    });
};

module.exports = createInjector({
    container: createContainerView,
    matchedResults: createMatchedResultsView,
    tags: createTagsView,
});
